var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot"},[_c('div',{staticClass:"top"},[_vm._v("Copyright 2020-2023     橙杏健康")]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v("下载APP体验更多服务")]),_vm._v(" "),_c('div',{staticClass:"download",on:{"click":_vm.downLoad}},[_vm._v("下载APP")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b51f2de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/footer.vue
// module id = null
// module chunks = 